// import json from './database-list.json';

export const dronePlatforms = [
  'droneSchool-platform-1',
  'droneSchool-platform-2',
  'droneSchool-platform-3',
] as const;
export const dashboard = ['dashboard-admin'] as const;

export type ProjectDatabaseType = {
  dronePlatforms: typeof dronePlatforms;
  dashboard: typeof dashboard;
};

const url = process.env.NEXTAUTH_URL ?? 'http://localhost:3000';
const isDev = url.startsWith('https://dev');
const isStg = url.startsWith('https://stg');

let env = '';
env = isDev ? 'dev-' : env;
env = isStg ? 'stg-' : env;

const SERVER_URL =
  process.env.NEXTAUTH_URL === 'http://localhost:3000'
    ? 'http://0.0.0.0:8080'
    : `https://${env}api.school-management-platform.jp`;

const getPublicSchema = async () => {
  const schemaDataRes = await fetch(`${SERVER_URL}/api/public-schema`);
  const schema = await schemaDataRes.json();
  const data = schema.data.reduce(
    (
      accu: { droneSchool: string[]; school: string[]; dashboard: string[] },
      element: {
        schooltype: 'droneSchool' | 'school' | 'dashboard';
        name: string;
        isactive: boolean;
      },
    ) => {
      if (element.isactive) {
        accu[element.schooltype].push(element.name);
      }
      return accu;
    },
    {
      droneSchool: [],
      school: [],
      dashboard: [],
    },
  );
  return data;
};
// eslint-disable-next-line arrow-body-style
export const fetchDroneDatabasesList = async () => {
  const droneSchoolSchema = await getPublicSchema();
  return droneSchoolSchema as { droneSchool: ProjectDatabaseType['dronePlatforms'][number][] };
};

// eslint-disable-next-line arrow-body-style
export const fetchDashboardDatabasesList = async () => {
  const dashboardSchema = await getPublicSchema();
  return dashboardSchema as { dashboard: ProjectDatabaseType['dashboard'][number][] };
};

// // eslint-disable-next-line arrow-body-style
// export const fetchDroneDatabasesList = async () => {
//   // https://raw.githubusercontent.com/asemqaffaf/json-hosting/main/data-platform.json
//   const res = await fetch(
//     'https://raw.githubusercontent.com/asemqaffaf/json-hosting/main/data-platform.json',
//   );
//   const data = await res.json();
//   return data.dronePlatforms as any[];
//   // return json as { droneSchool: ProjectDatabaseType['dronePlatforms'][number][] };
// };

// // eslint-disable-next-line arrow-body-style
// export const fetchDashboardDatabasesList = async () => {
//   const res = await fetch(
//     'https://raw.githubusercontent.com/asemqaffaf/json-hosting/main/data-platform.json',
//   );
//   const data = await res.json();
//   return data as { dashboard: ProjectDatabaseType['dashboard'][number][] };

//   // return json as { dashboard: ProjectDatabaseType['dashboard'][number][] };
// };
